<template>
  <widget
    @closed="$emit('closed')"
    @search="toggleSearch"
    title="dati lavoratori"
    icon="mdi-account-group"
    dark
    :bgColor="colors.orange"
    searchButton
    scroll
  >
    <transition name="fade" appear>
      <v-row v-if="searchBtn" class="px-3 py-0 ma-0 search-bar">
        <v-text-field
          class="mx-1"
          label="Ricerca rapida"
          clearable
          v-model="search"
        ></v-text-field>
      </v-row>
    </transition>
    <v-list dense>
      <v-list-item v-for="(employee, i) in filteredList" :key="i">
        <v-list-item-avatar
          size="20"
          :color="getColor(getIniziali(employee))"
          class="ml-1"
        >
          <div
            class="white--text text-little text-center text-uppercase"
            style="width: 100%"
          >
            {{ getIniziali(employee) }}
          </div>
        </v-list-item-avatar>
        <v-list-item-content class="pa-0">
          <v-list-item-title class="text-capitalize text-little box-name">
            {{ employee.cognome }} {{ employee.nome }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-little">{{
            employee.inquadramento
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon
            class="mt-3"
            color="primary"
            @click="
              $router.push({
                path: '/employees/profile',
                query: { cf: employee.codiceFiscale, id: idCompany },
              })
            "
          >
            mdi-eye
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </widget>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Widget from "./Widget.vue";
import mixin from "@/mixin";

export default {
  name: "dati-lavoratori",
  mixins: [mixin],
  components: {
    Widget,
  },
  mounted() {
    this.fetchEmployees();
  },
  data() {
    return {
      searchBtn: false,
      search: "",
    };
  },
  methods: {
    toggleSearch() {
      this.searchBtn = !this.searchBtn;
    },
    ...mapActions({
      fetchEmployees: "widget/fetchEmployees",
    }),
  },
  computed: {
    ...mapGetters({
      employees: "widget/employees",
    }),
    filteredList() {
      return this.search
        ? this.employees.filter((item) => {
            return `${item.nome}${item.cognome}${item.nome}${item.cognome}`
              .trim()
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(" ", "").trim());
          })
        : this.employees;
    },
  },
};
</script>

<style>
.space {
  padding: 0px !important;
  margin: 0px !important;
}
</style>